import { setGlobal } from 'reactn'
import { listUserSaleContracts_listUserSaleContracts } from '../types/listUserSaleContracts'

export const setActualSaleContract = (input: listUserSaleContracts_listUserSaleContracts) => {
  setGlobal({
    actualSaleContract: input,
  })
}
